import { css } from 'lit';

export const styles = css`:host igc-button{--ig-size: 2}[part~=base]{min-height:2.25rem;padding:.25rem 1rem}igc-button::part(base),igc-button::part(base):hover{color:var(--button-color);box-shadow:none}`;
